/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {IxModule} from '@siemens/ix-angular';
import {NgxPermissionsModule} from 'ngx-permissions';
import {ListBatteryObject} from '../../../../../models/ListBattery';

@Component({
  selector: 'app-dropdown-cell-renderer',
  standalone: true,
  imports: [RouterModule, TranslateModule, IxModule, NgxPermissionsModule],
  templateUrl: './dropdown-cell-renderer.component.html',
  styleUrl: './dropdown-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public passportData!: ListBatteryObject;
  public isReady = false;
  public isDataManager = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.passportData = params.data as ListBatteryObject;
    this.isDataManager = this.params.context?.isDataManager || false;
    this.isReady = !!this.passportData?.id;
  }

  refresh() {
    return false;
  }

  onShowQrClick(): void {
    this.executeAction('qr-code');
  }

  onAddIndividualPassportClick(): void {
    this.executeAction('addIndividual');
  }

  onRemovePassportClick(): void {
    this.executeAction('delete');
  }

  isMasterPassport(): boolean {
    return this.passportData?.metadata.masterChildFlag === 'MASTER';
  }

  private executeAction(action: string): void {
    this.params.context?.componentParent?.handleActionClick(
      action,
      this.passportData.id,
    );
  }

  get dropdownId(): string {
    return `listBatteryItemDropdown.${this.passportData.id}`;
  }
}
